export default __webpack_public_path__ + "static/media/Community.6ca23f7a.svg";